export const scrollToElement = async (id: string) => {
  const el = document.getElementById(id)
  if (!el) return

  const ionContent = el.closest('ion-content') as HTMLIonContentElement | null
  if (!ionContent) return

  const scrollEl = await ionContent.getScrollElement()

  const targetTop = el.getBoundingClientRect().top // the target's top from visible screen
  const alreadyScrolled = scrollEl.scrollTop // the content in ion-content which is already scrolled
  const visibleScreenHeight = scrollEl.clientHeight

  const elementAbsoluteTop = targetTop + alreadyScrolled
  const center = elementAbsoluteTop - visibleScreenHeight / 2

  ionContent.scrollToPoint(0, center, 500)
}
